import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { UserComponent } from './user/user.component';
import { ToursComponent } from './tours/tours.component';
import { TourDetailComponent } from './tour-detail/tour-detail.component';
import { AuthGuard } from './guards/auth.guard';
import { TourDetailGuard } from './guards/tour-detail.guard';
import { ProfileGuard } from './guards/profile.guard';

const routes: Routes = [
  { path: 'registro', component: RegisterComponent, canActivate : [AuthGuard] },
  { path: 'inicio', component: WelcomeComponent },
  { path: 'perfil', component: UserComponent, canActivate : [ProfileGuard] },
  { path: 'tours', component: ToursComponent },
  { path: 'tour/:id/:modo', component: TourDetailComponent, canActivate : [TourDetailGuard] },
  { path: 'crear', component: TourDetailComponent, canActivate : [TourDetailGuard] },
  { path: '**', redirectTo: 'inicio', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
